<template>
	<div class="form-actions">
		<button :form="form" type="submit" :class="btnSubmitClassList">
                <font-awesome-icon icon="save" />
                {{ btnSubmitText }}
        </button>
	</div>
</template>
<script>
export default {
	props: {
		form: {
			type: String,
			required: false,
			default: () => 'container__form',
		},
		levels: {
			type: Array,
			required: false,
			default: () => ['id'],
		},
	},
	computed: {
		btnSubmitText() {
			if (this.checkLevels(this.levels.slice())) {
				return 'save changes'
			}
			return 'create'
		},
		btnSubmitClassList() {
			return 'btn btn-md btn btn-' + (this.checkLevels(this.levels.slice()) ? 'primary' : 'primary')
		},
	},
	methods: {
		checkLevels(levels, status = false) {
			if (!levels.length) return status
			var level = levels.splice(0, 1)[0]
			return this.checkLevels(levels, parseInt(this.$route.params[level]) > 0)
		},
	},
	mounted() {},
}
</script>
